import { createContext, useContext } from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { getTest, deleteTest } from "../../api/testimonial";
import useToaster from "../../components/alert";
import Const from "../../utils/constant";
import { useNavigate } from "react-router-dom";

const PageContext = createContext();

const initialValues = {
  Banner: { heading: "", subheading: "", cta: "", ctaRedirectLink: "" },
};

export const PageProvider = ({ children }) => {
  const toaster = useToaster();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const getBlogsQuery = useQuery({
    queryKey: ["blogs"],
    queryFn: getTest,
  });

  const deleteBlogQuery = useMutation({ mutationFn: deleteTest });

  const handleWorkDelete = (item) => {
    deleteBlogQuery.mutate(item._id, {
      onSuccess: () => {
        queryClient.invalidateQueries(["blogs"]);
        toaster.success(Const.MESSAGES.SUCCESS, "Blog is deleted successfully.");
      },
    });
  };

  const handleAddBlogClick = () => {
    navigate("/testimonials/add");
  };

  const handleEditClick = (item) => {
    navigate(`/testimonials/add?id=${item._id}`);
  };

  return (
    <PageContext.Provider value={{ initialValues, getBlogsQuery, handleWorkDelete, handleAddBlogClick, handleEditClick }}>
      {children}
    </PageContext.Provider>
  );
};

export const useBlogsProvider = () => {
  return useContext(PageContext);
};
